import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterStateSnapshot } from '@angular/router';
import { NotFoundComponent } from './not-found.component';
import { notFoundRoute } from './not-found.route';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
	declarations: [NotFoundComponent],
	imports: [CommonModule, SharedModule, RouterModule.forChild(notFoundRoute)],
	exports: [NotFoundComponent],
})
export class NotFoundModule {}
